module.exports = __webpack_public_path__ + "img/dot-money.e7cbc37c.png";